module.exports = __webpack_public_path__ + "img/reset_filter.8175aa03.svg";